<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row style="position:relative;">
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Поступление <span v-if="sale.org">({{ sale.org.legal_entity }})</span></div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Нормативы / Поступления /</span>  <span v-if="stock_name"> {{ stock_name }}</span><span v-else> Поступление</span></div>
                </div>
              </v-col>
              <v-col cols="12">
                <v-sheet
                    max-height="80px"
                    rounded="lg"
                    class="d-flex justify-space-between align-center card"
                >
  
                  <div>
                    {{ manager_1c_fio }}
                  </div>
    
                </v-sheet>
              </v-col>
              <v-col
                  cols="4"
                  v-if="type === 'new' || type === 'exist'"
              >
                <div v-if="type === 'exist'" style="background:#fff; width:100%; border:none; padding:10px 10px 10px 10px; border-top-right-radius: 10px; border-top-left-radius: 10px;     border-bottom: 1px solid #e0e0e0;">
                  <v-tabs
                      centered
                      id="horizontal_tabs"
                      v-model="sale_tab"
                      class="d-flex align-center sale__tab"
                  >
                    <v-tab
                        v-for="item in stockS1"
                        :key="item.tab"
                        class="ml-4"
                    >
                      {{ item.tab }}
                    </v-tab>
                  </v-tabs>
                </div>
                <div v-else style="background:#fff; width:100%; border:none; padding:10px 0px 10px 0px; border-top-right-radius: 10px; border-top-left-radius: 10px;     border-bottom: 1px solid #e0e0e0;">
                  <v-tabs
                      id="horizontal_tabs"
                      v-model="sale_tab"
                      class="d-flex align-center sale__tab"
                  >
                    <v-tab
                        v-for="item in stockS2"
                        :key="item.tab"
                        class="ml-4"
                    >
                      {{ item.tab }}
                    </v-tab>
                  </v-tabs>
                </div>
                <v-tabs-items v-model="sale_tab">
                  <v-tab-item v-if="type === 'new'">
                    <v-skeleton-loader
                        v-if="isLoadingSale && (type === 'new' || type === 'exist')"
                        type="table-tbody"
                    >
                    </v-skeleton-loader>
                    <v-sheet
                        v-else
                        class="card"
                        rounded="lg"
                    >
                      <v-text-field

                          v-model="searchService"
                          hide-details
                          dense
                          required
                          label="Поиск"
                          outlined
                          style="font-weight: 400; font-size: 16px; line-height: 24px;"
                          background-color="white"
                          color="#629F33"
                          class="search-service"
                          @input="handleSearch"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>mdi-magnify</v-icon>
                        </template>
                      </v-text-field>
                      <template>
                        <v-treeview
                            :items="listAllReceipts.stock"
                            item-key="id"
                            item-text="name"
                            :search="searchService"
                            expand-icon="mdi-chevron-down"
                            open-on-click
                            item-children="list"
                            :filter="searchPackages"
                            ref="myTree"
                        >
                          <template v-slot:label="{ item, leaf }">
                            <v-list-item
                                class="service"
                                v-if="leaf"
                                :key="item.name"
                                @click="addToNomenclature(item)"
                            >
                              <v-list-item-title class="d-flex justify-space-between">
                                <span class="service-title">{{ item.name }}</span>
                                <span class="service-price" v-if="item.price">{{ item.free ? 'беспл.' : item.price + '  ₽' }}</span>
                              </v-list-item-title>
                            </v-list-item>
                 
                            <v-list-item
                                :key="item.name"
                                class="services"
                                v-else
                            >
                              <v-list-item-title>{{ item.name }}</v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-treeview>
                      </template>
                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet
                        class="card"
                        rounded="lg"
                        v-if="type === 'new' || type === 'exist'"
                    >
                      <div v-if="type === 'new'">
                        <label>Номер</label>
                        <v-text-field
                            v-model="stockNew.number"
                            label="Номер"
                            outlined
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>

                      <div v-else>
                        <label>Номер</label>
                        <v-text-field
                            v-if="stockInfo && stockInfo.stock && stockInfo.stock.number"
                            v-model="stockInfo.stock.number"
                            label="Номер"
                            outlined
                            readonly
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>

                      <div v-if="type === 'new'">
                        <label>Дата</label>
                        <template>
                          <VueDatePicker
                              no-title
                              no-header
                              color="#629f34"
                              v-model="stockNew.date"
                              placeholder="Дата"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__datepicker"
                                  ref="activator"
                                  type="button"
                              >
                                <div>
                                  <span v-if="date">{{ date }}</span>
                                  <span v-else style="color: gray">Дата</span>
                                </div>
                                <div>
                                  <v-icon
                                      medium
                                      right
                                      class="ml-5"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                </div>
                              </button>
                            </template>
                          </VueDatePicker>
                        </template>
                      </div>

                      <div class="mt-5" v-else>
                        <label>Дата</label>
                        <template>
                          <VueDatePicker
                              v-if="stockInfo && stockInfo.stock && stockInfo.stock.date"
                              no-title
                              no-header
                              color="#629f34"
                              v-model="stockInfo.stock.date"
                              placeholder="Дата"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__datepicker"
                                  ref="activator"
                                  type="button"
                              >
                                <div>
                                  <span v-if="date">{{ date }}</span>
                                  <span v-else style="color: gray">Дата</span>
                                </div>
                                <div>
                                  <v-icon
                                      medium
                                      right
                                      class="ml-5"
                                  >
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                </div>
                              </button>
                            </template>
                          </VueDatePicker>
                        </template>
                      </div>

                      <div v-if="type === 'new'">
                        <label>Автор</label>
                        <v-text-field
                            v-model="stockNew.user.name"
                            label="Автор"
                            outlined
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>

                      <div class="mt-5" v-else>
                        <label>Автор</label>
                        <v-text-field
                            v-if="stockInfo && stockInfo.stock && stockInfo.stock.user"
                            v-model="stockInfo.stock.user.name"
                            label="Автор"
                            outlined
                            readonly
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>

                      <div v-if="type === 'new'">
                        <label>Комментарий</label>
                        <v-text-field
                            v-model="stockNew.comment"
                            label="Комментарий"
                            outlined
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>

                      <div class="mt-5" v-else>
                        <label>Комментарий</label>
                        <v-text-field
                            v-if="stockInfo && stockInfo.stock"
                            v-model="stockInfo.stock.comment"
                            label="Комментарий"
                            outlined
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>
                    </v-sheet>
             
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
              <v-col
                  :cols="(type === 'exist') ? 8 : 8"
                  style="position: relative"
              >

              <v-row style="position:relative;">
                <v-col
                  style=""
                >
                <v-skeleton-loader
                  v-if="isLoadingSale"
                  type="table"
                >

                </v-skeleton-loader>
                <v-sheet rounded="lg" class="card" style="width: 100%; padding: 0 !important;" v-else>

                  <div style="display:flex; flex-direction: column;">
                    <div class="d-flex justify-space-between" style="padding: 10px 20px 0 20px">
                      <div class="mt-5 w-50" v-if="type === 'new'">
                        <label>Вид операции</label>
                        <v-text-field
                            v-model="stockNew.type.name"
                            label="Вид операции"
                            outlined
                            dense
                            readonly
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>
                      <div class="mt-5 w-50" v-else>
                        <label>Вид операции</label>
                        <v-text-field
                            v-if="stock_name"
                            v-model="stock_name"
                            label="Вид операции"
                            outlined
                            dense
                            readonly
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>

                      <div class="mt-5 w-50" v-if="type === 'new'">
                        <label>Контрагент</label>
                        <v-select
                            v-model="stockNew.supplier"
                            :items="(listSuppliers && listSuppliers.stock) ? listSuppliers.stock : defSuppliers"
                            item-value="id"
                            item-text="name"
                            return-object
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            style="height: 48px;margin-top: 10px"
                        ></v-select>
                      </div>

                      <div class="mt-5 w-50" v-else>
                        <label>Контрагент</label>
                        <v-text-field
                            v-if="stockInfo && stockInfo.stock && stockInfo.stock.client"
                            v-model="stockInfo.stock.client.name"
                            label="Контрагент"
                            outlined
                            dense
                            readonly
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>
                
                  </div>

                  <div class="d-flex justify-space-between" style="padding: 5px 20px 0 20px">

                    <div class="mt-5 w-50" v-if="type === 'new'">
                        <label>Склад</label>
                        <v-select
                            v-model="stockNew.storage"
                            :items="(listStorages && listStorages.stock) ? listStorages.stock : defStorages"
                            item-value="id"
                            item-text="name"
                            return-object
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            style="height: 48px;margin-top: 10px"
                        ></v-select>
                      </div>

                    <div class="mt-5 w-50" v-else>
                        <label>Склад</label>
                        <v-text-field
                            v-if="stockInfo && stockInfo.stock && stockInfo.stock.storage"
                            v-model="stockInfo.stock.storage.name"
                            label="Склад"
                            outlined
                            dense
                            readonly
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                      </div>


                      <div class="mt-5 w-50" v-if="type === 'new'">
                        <label>Организация</label>
                          <v-select
                            v-model="stockNew.org"
                            :items="listOrganizations.sales"
                            item-value="id"
                            item-text="name"
                            return-object
                            class="rounded-lg"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            append-icon="mdi-chevron-down"
                            outlined
                            dense
                            required
                            
                            style="height: 48px;margin-top: 10px"
                        ></v-select>

                        <!-- @change="ChangeSaleOrg()" -->
                      </div>

                    <div class="mt-5 w-50" v-else>
                        <label>Организация</label>
                        <v-text-field
                            v-if="stockInfo && stockInfo.stock && stockInfo.stock.org"
                            v-model="stockInfo.stock.org.name"
                            label="Автор"
                            outlined
                            dense
                            style="height: 48px;margin-top: 10px"
                            class="rounded-lg"
                        ></v-text-field>
                  
                      </div>
                  </div>


                  </div>
                  <v-data-table
                      v-if="type === 'exist' || type === 'edit' || type === 'info'"
                      :headers="type === 'exist' ? headersExistStock : headersExistNomenclature"
                      :items="stockInfo.stock.stock_list"
                      no-data-text="Нет добавленных поступлений"
                      :hide-default-footer="true"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      item-key="service.name"
                      class="elevation-1 mt-3 rounded-b-0 custom__table"
                  >
                    <template v-slot:item.service.name="{ item }">
                      {{  item.service.name }} 
                    </template>

                    <template v-if="type === 'exist'" v-slot:item.count="{ item }">
                      <div class="d-flex justify-space-between">
                        <div class="logo-bg" @click="subtractCountNomenclature(item)">
                          <img src="/playground_assets/minus-circle-logo.svg" alt="">
                        </div>
                        <div>{{ item.count }}</div>
                        <div class="logo-bg" @click="addCountNomenclature(item)">
                          <img src="/playground_assets/smallpluscircle3282-42rl.svg" alt="">
                        </div>
                      </div>
                    </template>

                    <template v-slot:item.aa="{ item }">
                        <span>{{item.price*item.count}}</span>
                    </template>

                  <template v-slot:item.total="{ item }">
                    <span>{{item.count}}</span>
                  </template>

                    <template v-if="type === 'exist'" v-slot:item.actions="{ item }">
                      <div class="logo-bg" @click="deleteFromNomenclature(item)"><img src="/playground_assets/trash-logo.svg" alt=""></div>
                    </template>
                    <template v-slot:body.append>
                      <tr>
                        <td colspan="12">
                          <div class="d-flex justify-space-between total-price">
                            <span>Итого с НДС</span>
                            <span>{{ type === 'exist' ?  stockInfo.stock.stock_list.reduce((res, i) => res + i.total, 0) : stockInfo.stock.summ }} ₽</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="12">
                          <div class="d-flex justify-space-between total-price">
                            <span>Итого</span>
                            <span>{{ type === 'exist' ?  stockInfo.stock.stock_list.reduce((res, i) => res + i.total, 0) : stockInfo.stock.summ }} ₽</span>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>

                  <v-data-table
                      v-if="type === 'new'"
                      :headers="headersStock"
                      :items="nomenclatures"
                      no-data-text="Нет добавленных поступлений"
                      :hide-default-footer="true"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      item-key="name"
                      class="elevation-1 mt-3 rounded-b-0 custom__table"
                  >
                  <template v-slot:item.service.name="{ item }">
                    {{  item.service.name }} 
                  </template>
                  <template v-slot:item.aa="{ item }">
                        <span>{{item.price*item.count}}</span>
                    </template>

                  <template v-slot:item.total="{ item }">
                    <span>{{item.count}}</span>
                  </template>
                    <template v-slot:item.count="{ item }">
                      <div class="d-flex justify-space-between">
                        <div class="logo-bg" @click="subtractCountNomenclature(item)">
                          <img src="/playground_assets/minus-circle-logo.svg" alt="">
                        </div>
                        <div>{{ item.count }}</div>
                        <div class="logo-bg" @click="addCountNomenclature(item)">
                          <img src="/playground_assets/smallpluscircle3282-42rl.svg" alt="">
                        </div>
                      </div>
                    </template>
     
               
                    <template v-slot:item.actions="{ item }">
                      <div class="logo-bg" @click="deleteFromNomenclature(item)"><img src="/playground_assets/trash-logo.svg" alt=""></div>
                    </template>
          
                    <template v-slot:body.append>
                      <tr>
                        <td colspan="12">
                          <div class="d-flex justify-space-between total-price">
                            <span>Итого с НДС</span>
                            <span>{{ nomenclatures.reduce((res, i) => res + i.total, 0) }} ₽</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="12">
                          <div class="d-flex justify-space-between total-price">
                            <span>Итого</span>
                            <span>{{ nomenclatures.reduce((res, i) => res + i.total, 0) }} ₽</span>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  <div v-if="type !== 'info' && !rentaItemDialog" class="d-flex justify-space-between" style="padding: 20px">
                
                    <div>
              
                      <v-btn class="button__success" :disabled="isLoadingSale || isLoading" @click="saveStock(true)">
                        Сохранить
                      </v-btn>

                    </div>
                  </div>
                </v-sheet>
              </v-col>
              </v-row>
            </v-col>
            </v-row>
          </v-container>
        </v-row>


      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";
import {salesActionTypes} from "@/store/modules/sale";
import {cashboxActionTypes} from "@/store/modules/cashbox";
import {getItem, setItem} from "../helpers/persistanceStorage";
import {billActionTypes} from "@/store/modules/bill";
import {dealsActionTypes} from "@/store/modules/deals";
import {lessonActionTypes} from "@/store/modules/lesson";
import {departmentActionTypes} from '@/store/modules/department';
export default {
  name: "SaleStock",
  props: ['stock_id','type', 'stock_name'],
  components: {
    VueDatePicker,
    Header,
    Menu
  },
  data() {
    return {
      dialogPayment2:null,
      salePart:true,
      sale_org_changed:false,
      searchService: null,
      showServices: false,
      dialogPayment: false,
      dialogClient: false,
      dialogTypeOfPayment: null,
      dialogTypeOfPaymentPart:[0,1,2,3],
      sale_tab: null,
      cashbox: null,
      cashboxRules: [
        v => !!v || 'Нужно выбрать кассу'
      ],
      main_bill: null,
      main_bill_part_def:null,
      main_bill_part:null,
      main_bill_part2:null,
      mainBillRules: [
        v => !!v || 'Нужно выбрать лицевой счет',
        v => parseInt(v.bill_balance) !== 0 || 'Нулевой баланс счёта'
      ],
      mainBonusRules: [
        v => !!v || 'Нужно выбрать бонусный счет',
        v => parseInt(v.bonus_balance) !== 0 || 'Нулевой баланс счёта',
        //v => parseInt(v.bonus_limit) < this.summ_bonus_part_pre || 'Превышен лимит'
      ],
      sortBy: 'total',
      sortDesc: false,
      check_to: 0,
      cash_in: null,
      //v => parseInt(v) !== 0 || 'Введите внесенную сумму'
      cashInFreeRules: [
        v => (v >= 0) || 'Введите внесенную сумму'
      ],
      cashInRules: [
        v => (v >= 0) || 'Введите внесенную сумму',
        v => parseInt(v) !== 0 || 'Введите внесенную сумму',
        v => !!v || 'Введите сумму'
      ],
      cash_out: 0,
      cash_from_bill: 0,
      cash_in_part: 0,
      cash_out_part: 0,
      // summ_cash_part:null,
      // summ_card_part:null,
      //v => parseInt(v) !== 0 || 'Введите сумму',
      //v => !!v || 'Введите сумму',
      cashFromBillRules: [
        v => parseInt(v) <= this.main_bill?.deposit_balance || 'Введите сумму не больше Л/С'
      ],
      buy_id_payment: null,
      sales: [
        {tab: 'Запасы'},
        {tab: 'Дополнительно'}
      ],
      stockS1: [
        {tab: 'Дополнительно'}
      ],
      stockS2: [
        {tab: 'Запасы'},
        {tab: 'Дополнительно'}
      ],
      sale: {
        number: null,
        date: new Date(),
        org: null,
        promocode: null,
      },
      listCashboxDef:[
        {
            inn:"1650387117",
            legal_entity:"OOO",
            serial:"0010872001250"
        },
        {
            inn:"165038711733",
            legal_entity:"IP",
            serial:"0010872001250333"
        }
      ],
      listCashbox: JSON.parse(getItem('list-cashbox')) ?? null,
      headersNomenclature: [
        {text: 'Наименование', sortable: false, value: 'service.name'},
        {text: 'Кол-во', sortable: false, value: 'count'},
        {text: 'Цена', sortable: false, value: 'price'},
        {text: 'Скидка', sortable: false, value: 'discount', width: '10%'},
        {text: 'Сумма', value: 'total'},
        {text: 'Исполнитель', sortable: false, value: 'aa'},
        {text: '', value: 'actions', sortable: false},
      ],
      headersExistNomenclature: [
        {text: 'Наименование', sortable: false, value: 'service.name'},
        {text: 'Кол-во', sortable: false, value: 'count'},
        {text: 'Цена', sortable: false, value: 'price'},
        {text: 'Скидка', sortable: false, value: 'discount'},
        {text: 'Сумма', value: 'total'},
        {text: 'Исполнитель', sortable: false, value: 'aa'},
      ],
      headersExistStock:[
        {text: 'Наименование', sortable: false, value: 'service.name'},
        {text: 'Кол-во', sortable: false, value: 'count'},
        {text: 'Цена', sortable: false, value: 'price'},
        {text: 'Сумма', value: 'aa'},
        {text: 'НДС', sortable: false, value: 'vat.summ'},
        {text: 'Всего', sortable: false, value: 'total'},
        {text: '', value: 'actions', sortable: false},
      ],
      headersStock:[
        {text: 'Наименование', sortable: false, value: 'service.name'},
        {text: 'Кол-во', sortable: false, value: 'count'},
        {text: 'Цена', sortable: false, value: 'price'},
        {text: 'Сумма', value: 'aa'},
        {text: 'НДС', sortable: false, value: 'vat.summ'},
        {text: 'Всего', sortable: false, value: 'total'},
        {text: '', value: 'actions', sortable: false},
      ],
      nomenclatures: [],
      specialist_id:null,
      caseSensitive:false,
      saleOrg:null,
      specialistDef:[
        {
          id:"1",
          name:"test1"
        },
        {
          id:"2",
          name:"test2"
        }
      ],
      myTree:[],
      cashboxTerminal:"f0eb54ae-0b16-11ec-a060-60e32700ce56",
      term_i:0,
      summ_cash_part:0,
      summ_card_part:0,
      summ_bill_part:0,
      summ_bill_part2:0,
      summ_part:0,
      main_bill_part_pre:0,
      summ_cash_part_pre:0,
      summ_card_part_pre:0,
      summ_bill_part_pre:0,
      summ_bill_part_pre2:0,
      cash_in_part_pre:0,
      cash_in_part_setted:false,
      card_part_setted:false,
      bill_part_setted:false,
      bill_part_setted2:false,
      bonus_part_setted:false,
      main_bonus_part:null,
      summ_bonus_part_pre:0,
      ifCardPay:false,
      ifCashPay:false,
      canAddSumm:false,
      buy_payment_list:null,
      rentaItemDialog:false,
      rentaItem:{},
      rentaItemDef:[
        {
          id:"e154f6f8-eced-11ea-812c-9c5c8e747603",
          name:"Аренда шкафчика на 6 месяцев (клевер)",
          price:"4950",
          date_time_start:null,
          date_time_end:null
        },
        {
          id:"23d56db0-ed07-11ea-812c-9c5c8e747603",
          name:"Аренда шкафчика на 1 месяц (клевер)",
          price:"1650",
          date_time_start:null,
          date_time_end:null
        },
        {
          id:"36aa21da-ef56-11ea-812c-9c5c8e747603",
          name:"Аренда шкафчика на год (VIP) (клевер)",
          price:"0",
          date_time_start:null,
          date_time_end:null
        }
      ],
      date:new Date(),
      manager_1c_id:getItem('user_id_1c'),
      manager_1c_fio:getItem('fio') ?? '',
      stockNew:{
        number:null,
        date:new Date(),
        user:{
          name:getItem('fio') ?? null,
          id:getItem('user_id_1c') ?? null
        },
        comment:null,
        type:{
          name:"Поступление",
          id:"1-34g-s"
        },
        supplier:null,
        storage:null,
        org:null,
        stock_list:[]
      },
      defSuppliers:[
        {
          id:"cf57d8da-fcb6-11ea-8136-9c5c8e747603",
          name:"Поставщик 1"
        },
        {
          id:"cf57d8da-fcb6-11ea-8136-9c5c8e747603-2",
          name:"Поставщик 2"
        }
      ],
      defStorages:[
        {
          id:"2eb1caa5-12bc-11e6-bbe7-001cc0386dec",
          name:"Основной (КлеверСпорт Н.Челны)"
        }
      ]
    }
  },
  methods: {
    saveStock(){
      
      if(this.type === 'exist' && this.stockInfo.stock && this.stockInfo.stock.id){
        console.log(this.stockInfo)
        console.log('Обновляем')
        if(!this.stockInfo.comment || this.stockInfo.comment.length < 3) {
          alert('Добавьте комментарий к изменению поступлений!')
          return;
        }
        let dataItem = this.stockInfo.stock
        this.$store.dispatch(departmentActionTypes.updateReceipt, {dataItem});
      }  else if(this.type === 'new'){
        if(!this.stockNew.org || !this.stockNew.org.inn) {
          alert('Не выбрана организация!')
          return;
        }
        if(!this.stockNew.supplier || !this.stockNew.supplier.id) {
          alert('Не выбран контрагент поступления!')
          return;
        }
        if(!this.stockNew.date) {
          alert('Не задана дата поступления!')
          return;
        }
        if(!this.stockNew.number) {
          alert('Не задан номер поступления!')
          return;
        }
        if(!this.nomenclatures) {
          alert('Не выбрано поступление!')
          return;
        }
        let list = [];
        let nomenclatures = [];
        nomenclatures = this.nomenclatures
        for (let item of nomenclatures) {
          list.push({
            service_id: item.service.id,
            name:item.service.name,
            price: item.price,
            count: item.count
          })
        }
        this.stockNew.stock_list = list
        console.log(this.stockNew)
        console.log('Создаём')
        let dataItem = this.stockNew
        this.$store.dispatch(departmentActionTypes.createReceipt, {dataItem});
      }
    },
    makeRental(){
      console.log(this.rentaItem)
    },
    buyDeletion(status){
      console.log(!status)

      let confirmText = "Пометить 'Продажа " + this.saleInfo.sales.summ + "р от " + this.saleInfo.sales.date + "' на удаление?"
      if(!status === false) {
        confirmText = "Снаять с 'Продажа " + this.saleInfo.sales.summ + "р от " + this.saleInfo.sales.date + "' пометку на удаление?"
      }

        if (confirm(confirmText) == true) {

          this.$store.dispatch(salesActionTypes.buyDelete, {
              buy_id: this.saleInfo.sales.id ? this.saleInfo.sales.id : null,
              status: !status
          })
          .then((response) => {
              console.log(response)
              this.$store.dispatch(salesActionTypes.getSaleInfo, {buy_id:this.saleInfo.sales.id});
          });

        }


    },
    checkSumm(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      } else {
        this.canAddSumm = true
      }
    },
    toCashPay(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      }
      if(this.ifCashPay){
        this.ifCashPay = false
        
        
        if(this.cash_in_part_setted){
          this.cash_in_part = this.cash_in_part - (+this.cash_in_part_pre)
        }
        this.cash_in_part_setted = false
        this.cash_in_part_pre = 0
      } else {
        this.cash_in_part_pre = this.summ_cash_part - this.cash_in_part
        this.ifCashPay = true
      }
    },
    toCardPay(){
      if(+this.cash_in_part >= +this.summ_cash_part){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        return;
      }
      if(this.ifCardPay){
        this.ifCardPay = false
        
        
        if(this.card_part_setted){
          this.cash_in_part = this.cash_in_part - (+this.summ_card_part_pre)
        }
        this.card_part_setted = false
        this.summ_card_part_pre = 0
      } else {
        this.summ_card_part_pre = this.summ_cash_part - this.cash_in_part
        this.ifCardPay = true
      }
    },
    setCashboxTerminal(){
      if(!this.listCashbox || !this.listCashbox[0]){
        alert('Не подключена или неполадки с кассой! Автоматически подставлена касса ИП Сорокин на Reception3_kl!')
      } 
      console.log(this.listCashbox)
      console.log(this.term_i)
      //if(this.listCashbox && this.listCashbox[this.term_i] && this.listCashbox[this.term_i].serial){
        console.log('по кассам')

        this.$store.dispatch(cashboxActionTypes.getCashboxDetail, {
          till_id: this.sale.org.serial
        }).then((resp) => {
        console.log(resp)
        if(resp && resp.cashbox && resp.cashbox.terminals && resp.cashbox.terminals.length > 0) {
            this.cashboxTerminal = resp.cashbox.terminals[0].id
          } else {
            this.cashboxTerminal = null
            alert('Нет доступного терминала по выбранной кассе!')
        }
        //  } else {
        //    alert('Неполадки с кассой, либо нет терминалов по выбранной кассе! Автоматически подставился стандартный теримнал ООО Клевер!')
        //  }
        })
     // }
    },
    handleSearch(input) {
      // console.log(+input)
      // if(input && +input && +input != NaN){
      //   input = '('+(+input)
      // }
      if (input && input.length >= 2) {
        this.$refs.myTree.updateAll(true)
      } else {
        this.$refs.myTree.updateAll(false)
      }
    },
    fetchFeed(stock_id, type){
      if (type === 'exist' || type === 'edit' || type === 'info') {
        console.log(stock_id)
        this.$store.dispatch(departmentActionTypes.getStockInfo, {stock_id});
      }
      if (type === 'new') {
        this.$store.dispatch(departmentActionTypes.getReceiptsAllList, {});
      }

      this.$store.dispatch(salesActionTypes.getSalesOrganizations, {});

      this.$store.dispatch(departmentActionTypes.getStockSuppliers, {});

    },
    addCountNomenclature(item){
      item.count++;
      item.total = item.price * item.count;
    },
    subtractCountNomenclature(item){
      if (item.count !== 1) {
        item.count--;
        item.total = item.price * item.count;
      }
    },
    addToNomenclature(item){

      console.log(item)
      //"e154f6f8-eced-11ea-812c-9c5c8e747603"
      //"23d56db0-ed07-11ea-812c-9c5c8e747603"
      //"36aa21da-ef56-11ea-812c-9c5c8e747603"

      if(item.id === "e154f6f8-eced-11ea-812c-9c5c8e747603" || item.id === "23d56db0-ed07-11ea-812c-9c5c8e747603" || item.id === "36aa21da-ef56-11ea-812c-9c5c8e747603"){
        this.rentaItem = {}
        this.rentaItem.id = item.id
        this.rentaItem.price = item.price
        this.rentaItem.name = item.name
        this.rentaItem.date_time_start = new Date()
        this.rentaItem.date_time_end = (new Date().getHours()+1) + ':00'

        console.log(this.rentaItem)

        this.$store.dispatch(salesActionTypes.getRentals,{});

        this.rentaItemDialog = true
      } else {

        let list = [];
        list = this.type === 'edit' ? this.saleInfo.sales.buy_list : this.nomenclatures;
        if (list.findIndex(n => n.service.id === item.id) !== -1) {
          let nomenclature = list.find(n => n.service.id === item.id);
          nomenclature.count++;
          nomenclature.total = nomenclature.total * nomenclature.count;
        } else {
          item.count = 1;
          let price = (item.price === -1 ? 0 : item.price);
          list.push({
            service: {
              id: item.id,
              name: item.name
            },
            price,
            count: item.count,
            discount: item.discount ? item.discount : 0,
            total: price * item.count,
            specialist_id:null
          });
        }

        this.$store.dispatch(lessonActionTypes.getSpecialistList,{service_id:item.id});

      }

    },
    deleteFromNomenclature(item){
      console.log(item)
      let list = [];
      list = this.type === 'exist' ? this.stockInfo.stock.stock_list : this.nomenclatures
      if (list.findIndex(n => n.service.id === item.service.id) !== -1) {
        list.splice(list.findIndex(n => n.service.id === item.service.id),1);
      }
    },
    saveSale() {

      if(this.buy_id || this.buy_id_payment){
        alert('Продажа сохранена!');
        this.$router.push({
        name: 'Desktop',
        arams: {
             client_id: this.client.client_id
            }
        });
      }

      let list = [];
      let nomenclatures = [];
      nomenclatures = this.type === 'edit' ? this.saleInfo.sales.buy_list : this.nomenclatures
      for (let item of nomenclatures) {
        console.log(item)
        list.push({
          service_id: item.service.id,
          name:item.service.name,
          price: item.price,
          count: item.count,
          discount: item.discount,
          discount_summ: (item.price * (item.discount/100)) * item.count,
          sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
          specialist_id: item.specialist_id,
          manager_id: getItem('user_id_1c') ? getItem('user_id_1c') : null,
          activation_date:item.service.activation_date_new,
        })
      }
      if (this.type === 'new') {

        if(this.sale.org && this.sale.org && this.sale.org.inn){

        } else {
          if(!this.saleOrg){

            if (confirm("Предупреждение. Не привязан ИНН (касса) и не выбрана организация! Автоматически будет выбрана организация ООО КлеверСпорт") == true) {
              for(var u in this.listOrganizations.sales) {
                if(this.listOrganizations.sales[u].inn === "1650387117"){
                  this.saleOrg = this.listOrganizations.sales[u]
                }
              }
              if(!this.saleOrg){
                this.saleOrg = this.listOrganizations.sales[0]
              }
            } else {
              for(var u in this.listOrganizations.sales) {
                if(this.listOrganizations.sales[u].inn === "1650387117"){
                  this.saleOrg = this.listOrganizations.sales[u]
                }
              }
              if(!this.saleOrg){
                this.saleOrg = this.listOrganizations.sales[0]
              }
              return;
            }


          }
        }

        // if(!this.sale_org_changed){
        //   alert('Выберите организацию!')
        //   return;
        // }

        this.$store.dispatch(salesActionTypes.createSale, {
          org_inn: (this.sale.org && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0),
          client_id: this.client.client_id,
          fio: this.userFIO,
          service_list: list,
          manager_id:getItem('user_id_1c')
        })
            .then((response) => {
              this.type = 'exist';
              this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
              this.fetchFeed(response.sale.buy_id, this.type);
      
            })
      }
      if (this.type === 'edit') {
        if(this.sale.org && this.sale.org && this.sale.org.inn){

        } else {
          if(!this.saleOrg){
            alert('Предупреждение. Не привязан ИНН (касса) и не выбрана организация!')
            return;
          }
        }
        this.$store.dispatch(salesActionTypes.editSale, {
          org_inn: (this.sale.org && this.sale.org && this.sale.org.inn) ? this.sale.org.inn : (this.saleOrg ? this.saleOrg.inn : 0),
          buy_id: this.saleInfo.sales.id,
          fio: this.userFIO,
          service_list: list
        })
            .then(() => {
              this.type = 'exist'
              this.fetchFeed(this.saleInfo.sales.id, this.type);
            })
      }

    },
    changeToEdit() {
      this.type = 'edit'
      this.fetchFeed(this.stock_id, this.type);
    },
    modalPayment() {

      
    // this.dialogPayment = true;
     this.main_bill_part_pre = 0
     console.log('aak')
     this.main_bill_part_pre2 = 0
     console.log('aak')
      this.summ_cash_part_pre = 0
      this.summ_card_part_pre = 0
      this.summ_bill_part_pre = 0
      this.cash_in_part_pre = 0
      this.cash_in_part_setted = false
      this.card_part_setted = false
      this.bill_part_setted = false
      this.bonus_part_setted = false

      this.ifCardPay = false
      this.ifCashPay = false

      this.cash_in_part = 0

      let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
      let resPrice = 0
      if(nomenclatures) {
        for (let item of nomenclatures) {
          resPrice += item.price
        }
      }

      let list = [];
      for (let item of nomenclatures) {
          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: getItem('user_id_1c') ? getItem('user_id_1c') : null
          })
      }

     if(this.buy_id || this.type === 'exist' || this.buy_id_payment){
        this.$store.dispatch(billActionTypes.getListBill,{
              client_id: this.client.client_id
            }).then((response2) => {
              if (response2.success)
                if(resPrice && resPrice > 0){
                  this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
                  this.summ_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
                }
            })

            //получаем бонусные счета после создания продажи
            this.$store.dispatch(billActionTypes.getListBonus,{
              client_id: this.client.client_id,
              buy_id: this.buy_id ? this.buy_id : this.buy_id_payment
            }).then((response3) => {
              if (response3.success){
                this.dialogPayment = true;
              }
            })

          return;
     }
            // this.$store.dispatch(billActionTypes.getListBill,{
            //   client_id: this.client.client_id
            // }).then((response2) => {
            //   if (response2.success)
            //     if(resPrice && resPrice > 0){
            //       this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
            //       this.summ_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
            //     }
            // })

        this.$store.dispatch(salesActionTypes.createSalePart, {
            org_inn: this.sale.org.inn,
            client_id: this.client.client_id,
            fio: this.userFIO,
            service_list: list,
            bonus_obj: this.main_bonus_part
        })
        .then((response) => {
          if (response.success) {
            //сохраняем айди продажи локально
            this.buy_id_payment = response.sale.buy_id;
            if(response.sale.service_list){
              this.buy_payment_list = response.sale.service_list
            }
            if(response.sale.sale_sum){
              this.summForPaymentPart = response.sale.sale_sum
            }
            this.$store.dispatch(billActionTypes.getListBill,{
              client_id: this.client.client_id
            }).then((response2) => {
              if (response2.success)
                if(resPrice && resPrice > 0){
                  this.summ_cash_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
                  this.summ_part = this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
                }
            })

            //получаем бонусные счета после создания продажи
            this.$store.dispatch(billActionTypes.getListBonus,{
              client_id: this.client.client_id,
              buy_id: this.buy_id_payment
            }).then((response3) => {
              if (response3.success){
                this.dialogPayment = true;
              }
            })
            
          } else {
            alert('Ошибка создания продажи!')
          }
        })
      
    },
    makeFreePayment(){

      console.log('freepayment')
      //return;

        // if(!this.sale || !this.sale.org || !this.sale.org.inn){
        //   alert('Не подключена или неполадки с кассой! Автоматически подставлена касса')
        //   return
        // }

        if(this.sale.org && this.sale.org && this.sale.org.inn){

        } else {
          if(!this.saleOrg){
            alert('Предупреждение. Не привязан ИНН (касса) и не выбрана организация!')
            return;
          }
        }

        if((this.dialogTypeOfPayment + 1) === 3) {
          if(!this.cashboxTerminal) {
            alert('Нет доступного терминала по выбранной кассе! Операция прекращается!')
            return;
          }
        }

        let list = [];
        let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
        for (let item of nomenclatures) {
          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: getItem('user_id_1c') ? getItem('user_id_1c') : null
          })
        }
        if (this.type === 'new') {
          this.$store.dispatch(salesActionTypes.createSale, {
            org_inn: this.sale.org.inn,
            client_id: this.client.client_id,
            fio: this.userFIO,
            service_list: list
          })
              .then((response) => {
                if (response.success) {
                  this.buy_id_payment = response.sale.buy_id;
                  this.$store.dispatch(cashboxActionTypes.saleReceipt, {
                    till_id: this.sale.org.serial,
                    type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
                    fio: this.userFIO,
                    service_list: list
                  })
                      .then((response) => {
                        if (response.success) {
                          this.$store.dispatch(cashboxActionTypes.makePayment, {
                            buy_id: this.buy_id_payment,
                            till_id: this.sale.org.serial,
                            type: this.dialogTypeOfPayment + 1,
                            summ: Math.abs(this.summForPayment),
                            check_number: response.receipt_number,
                            bill_id: (this.dialogTypeOfPayment + 1) === 2 ? this.main_bill?.deposit_id : null,
                            terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,
                            transaction_id: (this.dialogTypeOfPayment + 1) === 3 ? response.auth_code : null,
                            transaction_date: (this.dialogTypeOfPayment + 1) === 3 ? new Date() : null,
                            fio: this.userFIO,
                            service_list: list
                          })
                              .then((response) => {
                                if (response.success) {
                                  if (this.for === 'client') {
                                    this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
                                  } else {
                                    this.$store.dispatch(dealsActionTypes.updateSuccess, {
                                      deal_id: this.deal.id,
                                      buy_id: this.buy_id_payment
                                    }).then((response) => {
                                      if (response.success) {
                                        this.$router.push({
                                          name: 'Desktop',
                                          params: {
                                            client_id: this.client.client_id
                                          }
                                        });
                                      }
                                    })
                                  }
                                }
                              })
                        } else {
                          alert('Ошибка оплаты!');
                        }
                      })
                }
              })
        } else {
          this.$store.dispatch(cashboxActionTypes.saleReceipt, {
            till_id: this.sale.org.serial,
            type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
            fio: this.userFIO,
            service_list: list
          })
              .then((response) => {
                if (response.success) {
                  this.$store.dispatch(cashboxActionTypes.makePayment, {
                    buy_id: this.saleInfo.sales.id,
                    till_id: this.sale.org.serial,
                    type: this.dialogTypeOfPayment + 1,
                    summ: Math.abs(this.summForPayment),
                    check_number: response.receipt_number,
                    bill_id: (this.dialogTypeOfPayment + 1) === 2 ? this.main_bill?.deposit_id : null,
                    terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,
                    transaction_id: (this.dialogTypeOfPayment + 1) === 3 ? response.auth_code : null,
                    transaction_date: (this.dialogTypeOfPayment + 1) === 3 ? new Date() : null,
                    fio: this.userFIO,
                    service_list: list
                  })
                      .then((response) => {
                        if (response.success) {
                          if (this.for === 'client') {
                            this.$router.push({
                              name: 'Desktop',
                              params: {
                                client_id: this.client.client_id
                              }
                            });
                          } else {
                            this.$store.dispatch(dealsActionTypes.updateSuccess, {
                              deal_id: this.deal,
                              buy_id: this.saleInfo.sales.id
                            }).then((response) => {
                              if (response.success) {
                                this.$router.push({
                                  name: 'Desktop',
                                  params: {
                                    client_id: this.client.client_id
                                  }
                                });
                              }
                            })
                          }
                        }
                      })
                } else {
                  alert('Ошибка оплаты!');
                }
              })
        }
    },
    makePayment() {
      console.log('Оплата старт')
      console.log('makePayment')
      //return;
      console.log(this.cashboxTerminal)
      console.log(this.dialogTypeOfPayment)
      console.log(this.sale.org)

      if((this.dialogTypeOfPayment + 1) === 3) {
          if(!this.cashboxTerminal) {
            alert('Нет доступного терминала по выбранной кассе! Операция прекращается!')
            return;
          }
      }

      if (this.$refs.form.validate()) {
        console.log('summ to 1C:  ' + Math.abs(this.summForPayment))
        let list = [];
        let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
        for (let item of nomenclatures) {
          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: getItem('user_id_1c') ? getItem('user_id_1c') : null
          })
        }
        if (this.type === 'new') {
          this.$store.dispatch(salesActionTypes.createSale, {
            org_inn: this.sale.org.inn,
            client_id: this.client.client_id,
            fio: this.userFIO,
            service_list: list
          })
              .then((response) => {
                if (response.success) {
                  this.buy_id_payment = response.sale.buy_id;
                  this.$store.dispatch(cashboxActionTypes.saleReceipt, {
                    till_id: this.sale.org.serial,
                    type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
                    fio: this.userFIO,
                    service_list: list
                  })
                      .then((response) => {
                        if (response.success) {
                          this.$store.dispatch(cashboxActionTypes.makePayment, {
                            buy_id: this.buy_id_payment,
                            till_id: this.sale.org.serial,
                            type: this.dialogTypeOfPayment + 1,
                            summ: Math.abs(this.summForPayment),
                            check_number: response.receipt_number,
                            bill_id: (this.dialogTypeOfPayment + 1) === 2 ? this.main_bill?.deposit_id : null,
                            terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,
                            transaction_id: (this.dialogTypeOfPayment + 1) === 3 ? response.auth_code : null,
                            transaction_date: (this.dialogTypeOfPayment + 1) === 3 ? new Date() : null,
                            fio: this.userFIO,
                            service_list: list
                          })
                              .then((response) => {
                                if (response.success) {
                                  if (this.for === 'client') {
                                    this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
                                  } else {
                                    this.$store.dispatch(dealsActionTypes.updateSuccess, {
                                      deal_id: this.deal.id,
                                      buy_id: this.buy_id_payment
                                    }).then((response) => {
                                      if (response.success) {
                                        this.$router.push({
                                          name: 'Desktop',
                                          params: {
                                            client_id: this.client.client_id
                                          }
                                        });
                                      }
                                    })
                                  }
                                }
                              })
                        } else {
                          alert('Ошибка оплаты!');
                        }
                      })
                }
              })
        } else {
          this.$store.dispatch(cashboxActionTypes.saleReceipt, {
            till_id: this.sale.org.serial,
            type: this.dialogTypeOfPayment === 1 ? 4 : this.dialogTypeOfPayment + 1,
            fio: this.userFIO,
            service_list: list
          })
              .then((response) => {
                if (response.success) {
                  this.$store.dispatch(cashboxActionTypes.makePayment, {
                    buy_id: this.saleInfo.sales.id,
                    till_id: this.sale.org.serial,
                    type: this.dialogTypeOfPayment + 1,
                    summ: Math.abs(this.summForPayment),
                    check_number: response.receipt_number,
                    bill_id: (this.dialogTypeOfPayment + 1) === 2 ? this.main_bill?.deposit_id : null,
                    terminal_id: (this.dialogTypeOfPayment + 1) === 3 ? this.cashboxTerminal : null,
                    transaction_id: (this.dialogTypeOfPayment + 1) === 3 ? response.auth_code : null,
                    transaction_date: (this.dialogTypeOfPayment + 1) === 3 ? new Date() : null,
                    fio: this.userFIO,
                    service_list: list
                  })
                      .then((response) => {
                        if (response.success) {
                          if (this.for === 'client') {
                            this.$router.push({
                              name: 'Desktop',
                              params: {
                                client_id: this.client.client_id
                              }
                            });
                          } else {
                            this.$store.dispatch(dealsActionTypes.updateSuccess, {
                              deal_id: this.deal,
                              buy_id: this.saleInfo.sales.id
                            }).then((response) => {
                              if (response.success) {
                                this.$router.push({
                                  name: 'Desktop',
                                  params: {
                                    client_id: this.client.client_id
                                  }
                                });
                              }
                            })
                          }
                        }
                      })
                } else {
                  alert('Ошибка оплаты!');
                }
              })
        }
      }
    },
    makePaymentPart() {
      console.log('Оплата старт')
      console.log('makePARTPayment')
      console.log(this.main_bonus_part)
      console.log(this.main_bill_part)
      console.log(this.main_bill_part2)
      //return;
      console.log(this.cashboxTerminal)
      console.log(this.dialogTypeOfPayment)
      console.log(this.sale.org)

      console.log('--')
      console.log(this.cash_in_part)
      console.log(this.cash_in_part_pre)
      console.log(this.summ_card_part_pre)
      console.log(this.summ_bill_part_pre)
      console.log(this.summ_bonus_part_pre)
      console.log('--')

      let typeOfPartPayment = []

      if(!this.cash_in_part || this.cash_in_part <= 0){
        alert('Итоговая сумма внесено меньше суммы оплаты!');
        return;
      }

      if(Math.abs(this.summForPaymentPart) > Math.abs(this.cash_in_part)){
        alert('Итоговая сумма внесено меньше суммы оплаты!');
        return;
      }

      if(this.summ_card_part_pre && +this.summ_card_part_pre > 0) {
          if(!this.cashboxTerminal) {
            alert('Нет доступного терминала по выбранной кассе! Операция прекращается!')
            //return;
          }
      }

      if(this.cash_in_part_pre && (+this.cash_in_part_pre > 0) && !this.cash_in_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты наличными!") == true) {
          console.log('continue')
          
        } else {
          return;
        }
      } else if (this.cash_in_part_pre && (+this.cash_in_part_pre > 0)){
        typeOfPartPayment.push(0)
      }

      if(this.summ_card_part_pre && (+this.summ_card_part_pre > 0) && !this.card_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты картой!") == true) {
          console.log('continue')
          
        } else {
          return;
        }
      } else if (this.summ_card_part_pre && (+this.summ_card_part_pre > 0) ){
        typeOfPartPayment.push(2)
      }

      if(this.summ_bill_part_pre && (+this.summ_bill_part_pre > 0) && !this.bill_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты с личного счёта!") == true) {
          console.log('continue')
        } else {
          return;
        }
      } else if (this.summ_bill_part_pre && (+this.summ_bill_part_pre > 0)){
        typeOfPartPayment.push(1)
      }

      if(this.summ_bill_part_pre2 && (+this.summ_bill_part_pre2 > 0) && !this.bill_part_setted2) {
        if (confirm("Внимение, не подтверждена сумма для оплаты с личного счёта 2!") == true) {
          console.log('continue')
        } else {
          return;
        }
      } else if (this.summ_bill_part_pre2 && (+this.summ_bill_part_pre2 > 0)){
        typeOfPartPayment.push(7)
      }

      if(this.summ_bonus_part_pre && (+this.summ_bonus_part_pre > 0) && !this.bonus_part_setted) {
        if (confirm("Внимение, не подтверждена сумма для оплаты с бонусного счёта!") == true) {
          console.log('continue')
          
        } else {
          return;
        }
      } else if (this.summ_bonus_part_pre && (+this.summ_bonus_part_pre > 0)){
        this.main_bonus_part.val = this.summ_bonus_part_pre
        typeOfPartPayment.push(3)
      }

      //if (this.$refs.form.validate()) {
        console.log('summ to 1C:  ' + Math.abs(this.summForPaymentPart))
        console.log('summ to 1C:  ' + Math.abs(this.summ_part))
        // if(this.dialogTypeOfPaymentPart.includes(0)){
        //   if(!this.summ_cash_part || +this.summ_cash_part <= 0){
        //     alert('Неверная сумма к оплате наличными!');
        //     return;
        //   }
        //   if(!this.cash_in_part || +this.cash_in_part <= 0){
        //     alert('Неверная сумма внесено при оплате наличными!');
        //     return;
        //   }
        // }
          // if(!this.summ_bill_part || +this.summ_bill_part <= 0){
          //   alert('Неверная сумма к оплате со счёта!');
          //   return;
          // }
          if(this.main_bill_part && +this.summ_bill_part_pre > this.main_bill_part.deposit_balance){
            alert('Сумма списания со счёта превышает остаток на балансе счёта!');
            return;
          }
          if(this.main_bill_part2 && +this.summ_bill_part_pre2 > this.main_bill_part2.deposit_balance){
            alert('Сумма списания со счёта превышает остаток на балансе счёта!');
            return;
          }
          if(this.main_bonus_part && +this.summ_bonus_part_pre > this.main_bonus_part.bonus_balance){
            alert('Сумма списания с бонусного счёта превышает остаток на балансе счёта!');
            return;
          }
        // if(this.dialogTypeOfPaymentPart.includes(2)){
        //   if(!this.summ_card_part || +this.summ_card_part <= 0){
        //     alert('Неверная сумма к оплате картой!');
        //     return;
        //   }
        // }

        if(!this.sale || !this.sale.org|| !this.sale.org.inn) {
          alert('Не подключена или не выбрана касса!');
        }

        console.log(typeOfPartPayment)

        let list = [];
        let nomenclatures = this.type === 'new' ? this.nomenclatures : this.saleInfo.sales.buy_list;
        for (let item of nomenclatures) {
          list.push({
            service_id: item.service.id,
            price: item.price,
            count: item.count,
            discount: item.discount,
            discount_summ: (item.price * (item.discount/100)) * item.count,
            sum: (item.discount !== 0 ? item.price - (item.price * (item.discount / 100))  : item.price) * item.count,
            name:item.service.name,
            specialist_id: item.specialist_id,
            manager_id: getItem('user_id_1c') ? getItem('user_id_1c') : null
          })
        }

        if (this.type === 'new') {
          // this.$store.dispatch(salesActionTypes.createSalePart, {
          //   org_inn: this.sale.org.inn,
          //   client_id: this.client.client_id,
          //   fio: this.userFIO,
          //   service_list: list,
          //   bonus_obj: this.main_bonus_part
          // })
          //     .then((response) => {
          //       if (response.success) {
          //         this.buy_id_payment = response.sale.buy_id;
          //         if(response.sale.service_list){
          //           list = response.sale.service_list
          //         }
          //         if(response.sale.sale_sum){
          //           this.summForPaymentPart = response.sale.sale_sum
          //         }
                  this.$store.dispatch(cashboxActionTypes.saleReceiptPart, {
                    till_id: this.sale.org.serial,
                    type: typeOfPartPayment,
                    cash: this.cash_in_part_pre,
                    card: this.summ_card_part_pre,
                    bill: this.summ_bill_part_pre,
                    bill2: this.summ_bill_part_pre2,
                    bonus: this.summ_bonus_part_pre,
                    bonus_obj: this.main_bonus_part,
                    fio: this.userFIO,
                    service_list: this.buy_payment_list ? this.buy_payment_list : list,
                    buy_id: this.buy_id_payment,
                    summ: Math.abs(this.summForPaymentPart),
                    bill_id: (this.summ_bill_part_pre && +this.summ_bill_part_pre > 0) ? this.main_bill_part?.deposit_id : null,
                    bill_id2: (this.summ_bill_part_pre2 && +this.summ_bill_part_pre2 > 0) ? this.main_bill_part2?.deposit_id : null,
                    terminal_id: (this.summ_card_part_pre && +this.summ_card_part_pre > 0) ? this.cashboxTerminal : null,
                    transaction_date: new Date(),
                  })
                      .then((response) => {
                                if (response.success) {
                                  if (this.for === 'client') {
                                    this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
                                  } else {
                                    this.$store.dispatch(dealsActionTypes.updateSuccess, {
                                      deal_id: this.deal.id,
                                      buy_id: this.buy_id_payment
                                    }).then((response) => {
                                      if (response.success) {
                                        this.$router.push({
                                          name: 'Desktop',
                                          params: {
                                            client_id: this.client.client_id
                                          }
                                        });
                                      }
                                    })
                                  }
                                } else {
                                  alert('Ошибка оплаты 2!');
                                }
                    })
                        
         
        } else {
          // this.$store.dispatch(cashboxActionTypes.saleReceiptPart, {
          //   till_id: this.sale.org.serial,
          //   type: this.dialogTypeOfPaymentPart,
          //   cash: this.summ_cash_part,
          //   card: this.summ_card_part,
          //   bill: this.summ_bill_part,
          //   fio: this.userFIO,
          //   service_list: this.buy_payment_list ? this.buy_payment_list : list
          // })
          //     .then((response) => {
          //       if (response.success) {
          //         this.$store.dispatch(cashboxActionTypes.makePaymentPart, {
          //           buy_id: this.saleInfo.sales.id,
          //           till_id: this.sale.org.serial,
          //           type: this.dialogTypeOfPaymentPart,
          //           cash: this.summ_cash_part,
          //           card: this.summ_card_part,
          //           bill: this.summ_bill_part,
          //           summ: Math.abs(this.summForPaymentPart),
          //           check_number: response.receipt_number,
          //           bill_id: this.dialogTypeOfPaymentPart.includes(1) ? this.main_bill_part?.deposit_id : null,
          //           terminal_id: this.dialogTypeOfPaymentPart.includes(2) ? this.cashboxTerminal : null,
          //           transaction_id: this.dialogTypeOfPaymentPart.includes(2) ? response.auth_code : null,
          //           transaction_date: new Date(),
          //           fio: this.userFIO,
          //           service_list: list
          //         })
          //             .then((response) => {
          //               if (response.success) {
          //                 if (this.for === 'client') {
          //                   this.$router.push({
          //                     name: 'Desktop',
          //                     params: {
          //                       client_id: this.client.client_id
          //                     }
          //                   });
          //                 } else {
          //                   this.$store.dispatch(dealsActionTypes.updateSuccess, {
          //                     deal_id: this.deal,
          //                     buy_id: this.saleInfo.sales.id
          //                   }).then((response) => {
          //                     if (response.success) {
          //                       this.$router.push({
          //                         name: 'Desktop',
          //                         params: {
          //                           client_id: this.client.client_id
          //                         }
          //                       });
          //                     }
          //                   })
          //                 }
          //               }
          //             })
          //       } else {
          //         alert('Ошибка оплаты!');
          //       }
          //     })

          this.$store.dispatch(cashboxActionTypes.saleReceiptPart, {
                    till_id: this.sale.org.serial,
                    type: typeOfPartPayment,
                    cash: this.cash_in_part_pre,
                    card: this.summ_card_part_pre,
                    bill: this.summ_bill_part_pre,
                    bill2: this.summ_bill_part_pre2,
                    bonus: this.summ_bonus_part_pre,
                    bonus_obj: this.main_bonus_part,
                    fio: this.userFIO,
                    service_list: this.buy_payment_list ? this.buy_payment_list : list,
                    buy_id: this.buy_id_payment,
                    summ: Math.abs(this.summForPaymentPart),
                    bill_id: (this.summ_bill_part_pre && +this.summ_bill_part_pre > 0) ? this.main_bill_part?.deposit_id : null,
                    bill_id2: (this.summ_bill_part_pre2 && +this.summ_bill_part_pre2 > 0) ? this.main_bill_part2?.deposit_id : null,
                    terminal_id: (this.summ_card_part_pre && +this.summ_card_part_pre > 0) ? this.cashboxTerminal : null,
                    transaction_date: new Date(),
                  })
                      .then((response) => {
                                if (response.success) {
                                  if (this.for === 'client') {
                                    this.$router.push({
                                      name: 'Desktop',
                                      params: {
                                        client_id: this.client.client_id
                                      }
                                    });
                                  } else {
                                    this.$store.dispatch(dealsActionTypes.updateSuccess, {
                                      deal_id: this.deal.id,
                                      buy_id: this.buy_id_payment
                                    }).then((response) => {
                                      if (response.success) {
                                        this.$router.push({
                                          name: 'Desktop',
                                          params: {
                                            client_id: this.client.client_id
                                          }
                                        });
                                      }
                                    })
                                  }
                                } else {
                                  alert('Ошибка оплаты 2!');
                                }
                    })
        }
      //}
    },
    cancelReceipt() {
      this.$store.dispatch(cashboxActionTypes.cancelReceipt, {
        till_id: this.sale.org.serial,
        fio: this.userFIO
      })
    },
    ChangeSaleOrg(){
      this.sale_org_changed = true
    },
    setCashPart(status){
      if((+this.cash_in_part >= +this.summ_cash_part) && status){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        this.ifCashPay = false
        return;
      }
      // if(this.cash_in_part > this.summ_cash_part){
      //   alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
      //   this.ifCashPay = false
      // }
      if(+this.cash_in_part_pre > 0){
        this.cash_in_part_setted = status
        this.cash_in_part = status ? (this.cash_in_part + (+this.cash_in_part_pre)) : (this.cash_in_part - (+this.cash_in_part_pre))
      } else {
        this.cash_in_part_pre = 0
      }
      if(!status){
        this.ifCashPay = false
      }


    },
    setCardPart(status){
      if((+this.cash_in_part >= +this.summ_cash_part) && status){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
        this.canAddSumm = false
        this.ifCardPay = false
        return;
      }
      // if(this.cash_in_part > this.summ_cash_part){
      //   alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
      //   this.ifCardPay = false
      // }
      if(+this.summ_card_part_pre > 0){
        this.card_part_setted = status
        this.cash_in_part = status ? (this.cash_in_part + (+this.summ_card_part_pre)) : (this.cash_in_part - (+this.summ_card_part_pre))
      } else {
        this.summ_card_part_pre = 0
      }
      if(!status){
        this.ifCardPay = false
      }

    },
    setBillPart(status){
      if((this.cash_in_part > this.summ_cash_part) && status){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
        this.main_bill_part = null
        this.canAddSumm = false
      }
      if(+this.summ_bill_part_pre > 0){
        this.bill_part_setted = status
        this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bill_part_pre)) : (this.cash_in_part - (+this.summ_bill_part_pre))
      } else {
        this.summ_bill_part_pre = 0
      }

    },
    setBillPart2(status){
      if((this.cash_in_part > this.summ_cash_part) && status){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
        this.main_bill_part2 = null
        this.canAddSumm = false
      }
      if(+this.summ_bill_part_pre2 > 0){
        this.bill_part_setted2 = status
        this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bill_part_pre2)) : (this.cash_in_part - (+this.summ_bill_part_pre2))
      } else {
        this.summ_bill_part_pre2 = 0
      }

    },
    setBonusPart(status){
      if((this.cash_in_part > this.summ_cash_part) && status){
        alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
        this.main_bonus_part = null
        this.canAddSumm = false
      }
      if(this.summ_bonus_part_pre > this.main_bonus_part.bonus_limit){
        alert('Превышен лимит по бонусному счёту!')
        this.summ_bonus_part_pre = this.main_bonus_part.bonus_limit
        this.bonus_part_setted = false
      }
      if(+this.summ_bonus_part_pre > 0){
        this.bonus_part_setted = status
        this.cash_in_part = status ? (this.cash_in_part + (+this.summ_bonus_part_pre)) : (this.cash_in_part - (+this.summ_bonus_part_pre))

      } else {
        this.summ_bonus_part_pre = 0
      }

      console.log(this.summ_bonus_part_pre)
      console.log(this.main_bonus_part.bonus_limit)
      console.log(this.summ_cash_part)
      console.log(this.main_bonus_part)

    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.cashbox.isLoading,
      doingPayment: state => state.cashbox.doingPayment,
      isLoadingSale: state => state.sale.isLoadingSale,
      listAllReceipts: state => state.department.listAllReceipts,
      listBill: state => state.bill.list,
      listBonus: state => state.bill.bonus,
      saleInfo: state => state.sale.saleInfo,
      stockInfo: state => state.department.stock,
      userFIO: state => state.userFIO,
      specialist: state => state.lesson.specialist,
      validationErrors: state => state.cashbox.validationErrors,
      listOrganizations: state => state.sale.listOrganizations,
      listSuppliers: state => state.department.suppliers
    }),
    searchPackages() {
      let res = this.caseSensitive
        ? sayMyNane(item, search, textKey)
        : undefined

        function sayMyNane(item, search, textKey){
          (item[textKey2].indexOf(search) > -1)
        }

      return res

    },
    
    summ() {
      return this.type === 'new' ? this.nomenclatures.reduce((res, i) => res + i.total, 0) : this.saleInfo.sales.summ;
    },
    summForPayment() {
      let money = null;
      if (this.dialogTypeOfPayment === 0) {
        money = this.cash_in <= this.summ ? this.cash_in : this.summ;
      }
      if (this.dialogTypeOfPayment === 1) {
        money = this.cash_from_bill;
      }
      if (this.dialogTypeOfPayment === 2) {
        money = this.summ;
      }
      if (this.dialogTypeOfPayment === 3) {
        money = this.summ;
      }
      return money;
    },
    summForPaymentPart() {
      let money = null;
      if(this.dialogTypeOfPaymentPart.includes(0)){
        money = this.cash_in_part <= this.summ_part ? this.cash_in_part : this.summ_part;
      }
      if (this.dialogTypeOfPaymentPart.includes(1)) {
        if(this.dialogTypeOfPaymentPart.includes(0) && this.dialogTypeOfPaymentPart.includes(2)){
          money = +this.summ_bill_part + (+this.summ_cash_part) + (+this.summ_card_part);
        } else if(this.dialogTypeOfPaymentPart.includes(0)){
          money = +this.summ_bill_part + (+this.summ_cash_part);
        } else if(this.dialogTypeOfPaymentPart.includes(2)){
          money = +this.summ_bill_part + (+this.summ_card_part);
        } else {
          money = this.summ_bill_part;
        }
      }
      if (this.dialogTypeOfPaymentPart.includes(2)) {
        if(this.dialogTypeOfPaymentPart.includes(0) && this.dialogTypeOfPaymentPart.includes(1)){
          money = +this.summ_bill_part + (+this.summ_cash_part) + (+this.summ_card_part);
        } else if(this.dialogTypeOfPaymentPart.includes(0)){
          money = +this.summ_card_part + (+this.summ_cash_part);
        } else if(this.dialogTypeOfPaymentPart.includes(1)){
          money = +this.summ_bill_part + (+this.summ_card_part);
        } else {
          money = this.summ_card_part;
        }
      }

      return money;
    }
  },
  mounted() {

    this.type !== undefined ? setItem('sale-type',this.type) : this.type = getItem('sale-type');

    console.log(this.client)

    // if(this.client && this.client.id){
    //   setItem('sale-client',JSON.stringify(this.client))
    // } else if(this.client && this.client.client_id){
    //   setItem('sale-client',JSON.stringify(this.client))
    // } else {
    //   this.client = JSON.parse(getItem('sale-client'))
    // }

    // getItem('user_id_1c')
    // getItem('fio')

    this.stock_id !== undefined ? setItem('sale-stock_id',this.stock_id) : this.stock_id = getItem('sale-stock_id');

    if (JSON.parse(getItem('select_org-sale'))) {
      this.sale.org = JSON.parse(getItem('select_org-sale'));
    } else {
      this.sale.org = this.listCashbox ? this.listCashbox[0] : null;
    }
    this.fetchFeed(this.stock_id, this.type);
   
  },
  watch: {
    summ_cash_part(){
      if(this.dialogTypeOfPaymentPart.includes(2) && !this.dialogTypeOfPaymentPart.includes(1)){
        this.summ_card_part = this.summ_part - this.summ_cash_part;
        this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
      }
    },
    summ_card_part(){

      if(this.dialogTypeOfPaymentPart.includes(0) && !this.dialogTypeOfPaymentPart.includes(1)){
        this.summ_cash_part = this.summ_part - this.summ_card_part;
        this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
      }
    },
    cash_in_part() {

      if(this.dialogTypeOfPaymentPart.includes(2) && !this.dialogTypeOfPaymentPart.includes(1)){
        this.cash_out_part = (+this.cash_in_part + (+this.summ_card_part)) > this.summ_part ? ((+this.cash_in_part + (+this.summ_card_part)) - (+this.summ_part)) : 0;
      } else {
        this.cash_out_part = this.cash_in_part > this.summ_cash_part ? (this.cash_in_part - this.summ_cash_part) : 0;
      }
    },
    summ_bill_part(){
      console.log(this.summ_bill_part)
    },
    main_bill_part_def(){
      console.log(this.main_bill_part_def)
      if(this.main_bill_part && this.main_bill_part !== null){
        //уже выбран один
        console.log('уже есть один')
        
        if(this.main_bill_part_def !== null){

          if(+this.main_bill_part_def.deposit_balance > 0){
            this.main_bill_part2 = this.main_bill_part_def
          }

          if(+this.cash_in_part >= +this.summ_cash_part){
            alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
            this.canAddSumm = false
            if(this.main_bill_part_def.deposit_id === this.main_bill_part2.deposit_id){
              this.main_bill_part2 = null
            }
            
            return;
          }
          if(+this.main_bill_part2.deposit_balance <= 0){
            alert('Не верный баланс счёта')
            this.bill_part_setted2 = true

            this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre2)

            this.summ_bill_part_pre2 = 0

          } else {
            this.bill_part_setted2 = false
          }
        }

      } else {

        if(this.main_bill_part_def !== null){
          
          if(+this.main_bill_part_def.deposit_balance > 0){
            this.main_bill_part = this.main_bill_part_def
          }
          
          if(+this.cash_in_part >= +this.summ_cash_part){
            alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.')
            this.canAddSumm = false
            if(this.main_bill_part_def.deposit_id === this.main_bill_part.deposit_id){
              this.main_bill_part = null
            }
            return;
          }
          if(+this.main_bill_part.deposit_balance <= 0){
            alert('Не верный баланс счёта')
            this.bill_part_setted = true

            this.cash_in_part = this.cash_in_part - (+this.summ_bill_part_pre)

            this.summ_bill_part_pre = 0

          } else {
            this.bill_part_setted = false
          }
        }

      }
    },
    main_bonus_part(){
      if(this.main_bonus_part !== null){
        console.log(this.cash_in_part_pre)
        console.log(this.cash_in_part)
        console.log(this.summ_bonus_part_pre)
        console.log(this.main_bonus_part)
        if(+this.cash_in_part >= +this.summ_cash_part){
          alert('Сумма оплаты полностью покрывает сумму документа. Новый вид оплаты не может быть добавлен.');
          this.canAddSumm = false
          this.main_bonus_part = null
          return;
        }

        if(+this.main_bonus_part.deposit_balance <= 0){
          this.bonus_part_setted = true

          this.cash_in_part = this.cash_in_part - (+this.summ_bonus_part_pre)

          this.summ_bonus_part_pre = 0

        } else {
          this.bonus_part_setted = false
          this.summ_bonus_part_pre = this.main_bonus_part.bonus_limit
        }
      }
    },
    cash_in() {
      this.cash_out = this.cash_in > this.summ ? (this.cash_in - this.summ) : 0;
    },
    'sale.org'() {
      console.log(this.sale.org)
      setItem('select_org-sale',JSON.stringify(this.sale.org))
      if(+this.term_i === 0){
        this.term_i = 1
      } else {
        this.term_i = 0
      }
      this.setCashboxTerminal()
    },
    'salePart'(){
      console.log(this.salePart)
    },
    'dialogTypeOfPaymentPart'(){
      console.log(this.dialogTypeOfPaymentPart)
    }
  }
}
</script>

<style scoped>
#horizontal_tabs {
  flex: none;
  width: auto !important;
}
.logo-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #F1F1F1;
  border-radius: 25px;
}
.total-price > span {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
.service {
  width: 100%;
  padding: 0px 16px;
  gap: 16px;
  background: #ffffff;
  border: 1px solid #E0E0E0;
  border-radius: 12px;
  margin-top: 10px;
}
.service-title {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.service-price {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
}
.new-client {
  border-top: 1px solid #E0E0E0;
  margin: 0 16px 20px 16px;
  padding-top: 20px;

}
.new-client > span {
  margin-top: 20px;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #629F33;
  cursor: pointer;
}
.payment-text {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.no-data-text {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #767676;
  padding-left: 16px;
  padding-bottom: 16px;
}
.custom__select {
  width: 330px;
}
.custom__select.v-select--is-menu-active {
  outline: 4px solid #E0ECD6;
}
.search-service.v-input--is-focused {
  outline: 4px solid #E0ECD6;
}
.custom__text-field {
  font-size: 12px;
  font-weight: normal;
  padding: 20px 16px 16px 16px;
}
.custom__menu {
  max-height: 112px !important;
  max-width: 199px !important;
}
.custom__menu > .v-list > .v-list-item {
  min-height: 32px !important;
}
.custom__menu > .v-list > .v-list-item > .v-list-item__title {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
}
.vd-activator .custom__datepicker {
  width: 92% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #969696 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 9px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}


.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 48px!important;
  color: #767676!important;
  padding: 12px 20px;
  text-transform: none;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
.v-btn-toggle > v-btn {
  width: 25%;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: #ffffff;
}
.v-btn-toggle > .v-btn.v-btn--active > .v-btn__content > .v-icon {
  color: #629F33;
}

.button__secondary-text {
  text-indent: 0 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  text-transform: none !important;
}
.vd-activator .custom__datepicker2 {
border: unset !important;
    background: transparent !important;
    padding: 13px 16px !important;
    margin-top: 0px !important;
}

.vd-activator .custom__datepicker44 {

    margin: 0px 0px 0px -12px !important;
    border:1px solid #e0e0e0 !important;
}

.w-50 {
  width:47%;
}

</style>